import { Link } from 'react-router-dom';
import './VolverAlPanel.css';

function VolverAlPanel() {
  return (
    <div className="volver-panel">
      <Link to="/panel" className="btn-volver">
        ⬅ Volver al Panel
      </Link>
    </div>
  );
}

export default VolverAlPanel;
